module.exports = __webpack_public_path__ + "static/media/site-logo.35e3f897.png";